import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './index.css'
import { applyPalette, loadPaletteId } from './palettes'

// Re-apply the admin-chosen palette before React mounts so the
// first paint already wears the right colours. applyPalette is
// theme-aware — when the inline script in index.html has set
// data-theme="light" on <html>, the page-bg / aurora variables
// are deliberately skipped so the white-prominent light theme
// CSS in index.css cascades through.
applyPalette(loadPaletteId())

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
